module.exports = __webpack_public_path__ + "static/assets/20b65b0048bdfb7f456afd9d537acc5a.png";